import { ShieldCheck, Compass, Users, BookOpenCheck } from "lucide-react";

const ABOUT_IMG =
  "https://static.prod-images.emergentagent.com/jobs/31d155ce-47a0-43dd-83bf-91a719a86bf9/images/11cc1d4a317ec4477401af0fb804e544400376d47e2fcbd28ac91ed516cad96e.png";

const FEATURES = [
  {
    icon: Compass,
    title: "Guided, not sold",
    body: "We start with your life goals and design investments around them — never the other way around.",
  },
  {
    icon: ShieldCheck,
    title: "Fiduciary mindset",
    body: "Transparent, commission-aware recommendations that align with your best interest.",
  },
  {
    icon: Users,
    title: "Families, for decades",
    body: "Trusted by hundreds of families in Palanpur and across Gujarat for long-term wealth planning.",
  },
  {
    icon: BookOpenCheck,
    title: "Plans you understand",
    body: "Every projection, every SIP — explained in plain language, so you stay in control.",
  },
];

export default function AboutSection() {
  return (
    <section
      id="about"
      className="relative bg-[#0A0F1C] border-t border-white/10"
      data-testid="about-section"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-5 order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden border border-white/10 aspect-[4/5]">
              <img
                src={ABOUT_IMG}
                alt="Structured origami bird in navy and orange"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0F1C] via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6">
                <div className="text-[10px] uppercase tracking-[0.22em] text-[#F97316]">
                  Est. for Gujarat's savers
                </div>
                <div className="mt-2 font-heading text-2xl font-semibold">
                  Sahi Disha — the right direction.
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 order-1 lg:order-2">
            <div className="text-[11px] uppercase tracking-[0.22em] text-[#F97316]">
              About Sahi Disha
            </div>
            <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tighter leading-[1.1]">
              A lifetime of income, starting with the{" "}
              <span className="italic font-light text-slate-200">right SIP today.</span>
            </h2>
            <p className="mt-5 text-base text-slate-400 leading-relaxed max-w-2xl">
              Sahi Disha Financial Services Pvt. Ltd. helps Indian families convert regular savings
              into perpetual income. We blend disciplined SIPs, inflation-aware planning and
              step-up strategies — so you retire on your terms, not your employer's.
            </p>

            <div className="mt-10 grid sm:grid-cols-2 gap-6">
              {FEATURES.map(({ icon: Icon, title, body }) => (
                <div
                  key={title}
                  className="group rounded-xl border border-white/10 bg-white/[0.02] p-5 hover:bg-white/5 transition-colors"
                >
                  <div className="w-10 h-10 rounded-md bg-[#F97316]/15 border border-[#F97316]/30 flex items-center justify-center">
                    <Icon className="w-5 h-5 text-[#F97316]" />
                  </div>
                  <div className="mt-4 font-heading text-lg font-semibold">{title}</div>
                  <div className="mt-1.5 text-sm text-slate-400 leading-relaxed">{body}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
